import React from 'react'
import { FaEdit } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';

export default function PollListAction(props) {

    const { data, editModal, modalLoading, editForm, departmentUpdate } = props;

    const edit_poll = () => {
        modalLoading(true)
        editModal(true)
        editForm(props?.data)
        departmentUpdate(props?.data?.department_data)
        modalLoading(false)
    }

    return (
        <div>
            {data?.status === 'active' ?
                <FaEdit size={20} className='edit ms-3'
                    onClick={() => edit_poll()}
                    data-tooltip-id="edit"
                    data-tooltip-content="Edit Poll!"
                    data-tooltip-place="bottom"
                />
                :
                ''
            }
            <Tooltip id="edit" style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
        </div>
    )
}
